import { right_answer } from "../../constants/right_answer"

function customRound(value){
    // return Math.round(Math.round(value*1000)/10)/100;
    return Math.round(value*100)/100
    // return value
}

export default function countByFormulaTotal(data_results, data_coefficient){
    //data_results - data.results и data.esteem_results
    //coefficient - коэфициенты
    
    //количество разделов
    const count_part_name=Object.keys(data_results).length
    //список разделов
    const array_part_name=Object.keys(data_results)
    let coefficient=data_coefficient

    //Массив в котором сохраняется итоговые подсчитанные по формуле оценки
    const result_list = []

    //Список правильных ответов для теста
    const write_answer=right_answer

    for (var index_part_name in array_part_name){
        //название выбранного раздела
        let part_name=array_part_name[index_part_name]
        // //Коэфициент раздела
        // console.log("Коэфициенты:", coefficient)
        //Список подразделов в разделе
        let array_category=Object.keys(data_results[part_name])
        //счётчик положительных ответов в категориях
        let sum_yes_in_categories=0
        //объект для сохранения оценок в категориях
        let scors_in_categorie={}

        for (var index_category in array_category){
            //название выбранного подраздела
            let category = array_category[index_category]
            //список уровней в подразделе
            let array_level=Object.keys(data_results[part_name][category])
            //флаг для переключения подсчёта оценок
            let flag_zero=false
            //сумма положительных оценок в уровне
            let sum_yes_score_in_levels=0
            for (var index_level in array_level){
                //Выбранный уровень:
                let level=array_level[index_level]
                //Список заданий в уровне
                let array_tasks=data_results[part_name][category][level]

                // console.log(part_name,"-",category,"-",level,"-",JSON.stringify(array_tasks))
                //Подсчёт результатов в задании:
                //Количество отрицательных и неотвеченных вопросов
                let count_no_or_null_in_level=Object.values(array_tasks).filter(val => write_answer[val] !== true).length
                //Количество отвеченных вопросов
                let count_yes_in_level=Object.values(array_tasks).filter(val => write_answer[val] === true).length
                //Количество вопросов в уровне
                let count_tasks_in_level=Object.values(array_tasks).length
                //оценка на уровне
                let score=count_yes_in_level/count_tasks_in_level

                // console.log(part_name,"|",category,"|",level,"|",JSON.stringify(array_tasks),"| Количество заданий в уровне:",count_tasks_in_level,"| Количество нет и незаполненных ответов:",count_no_or_null_in_level,"| Колличество ДА:",count_yes_in_level,"| средная оценка на уровне:",score)
                
                if (flag_zero==false){
                    sum_yes_score_in_levels=sum_yes_score_in_levels+score
                    if (count_no_or_null_in_level!=0){
                        flag_zero=true
                    }
                }else{
                    sum_yes_score_in_levels=sum_yes_score_in_levels+0
                }
                
            }
            //сохраняем оценку и категорию
            Object.assign(scors_in_categorie, {[category]:sum_yes_score_in_levels})
            //сумма оценок в категориях подраздела
            sum_yes_in_categories=sum_yes_in_categories+sum_yes_score_in_levels
        }
        
        result_list.push({
            name: `${part_name}`,
            //оценка по разделу
            // value: `${Math.round(((sum_yes_in_categories/array_category.length)*100))/100}`,
            // value:`${customRound(sum_yes_in_categories/array_category.length)}`,
            value:customRound(sum_yes_in_categories/array_category.length),
            category_scors: scors_in_categorie
        })
    }
    //итоговая сумарная оценка аудита формула версия с коэфициентами
    const sum_scors=result_list.reduce((sum, current)=>{return sum+(current.value*coefficient[current.name])},0) 
    
    //Среднее арифметическое - финальная оценка по аудиту
    const final_summary=sum_scors

    const final_variant={
        "data_count":result_list,
        "summary":customRound(final_summary)
    }
    // console.log("ИТОГО:", final_variant)

    return(final_variant)

}
